<template>
	<div
		v-if="similarRelations"
		class="mb-10 lg:mb-20 flex gap-2 items-center flex-col"
	>
		<span class="text-3xl mb-4">
			{{ similarRelations.Name || $t("similar_products") }}
		</span>
		<Carousel
			:slides="similarRelations.Items || []"
			:type-of-slide="ItemType.PRODUCT"
			:blok="{ number_of_slides_to_show: '4', show_arrows: true }"
		/>
	</div>
</template>

<script setup lang="ts">
import type { SimplifiedProductRelations } from "@nwt/norce-pwa/dist/runtime/types/api/product/product";
import { ref } from "vue";
import Carousel from "~/storyblok/Carousel/Carousel.vue";
import { ItemType, ProductPrefix } from "~/utils/constants";

const { relations } = storeToRefs(useProductStore());

const similarRelations = ref<SimplifiedProductRelations | null>(null);

const currentRelations = computed(() => {
	const productRelations = relations.value as SimplifiedProductRelations[];
	const similarProducts = productRelations.find((relation) =>
		relation.Code.includes(ProductPrefix.SIMILAR_PRODUCTS)
	);

	if (similarProducts) {
		return similarProducts;
	}

	return (
		productRelations.find(
			(relation) => !relation.Code.includes(ProductPrefix.PACKAGE_PRODUCT)
		) || null
	);
});

watch(
	currentRelations,
	(newRelations: SimplifiedProductRelations) => {
		similarRelations.value = newRelations;
	},
	{ immediate: true }
);
</script>
